import { loadDynamicJS } from './loadDynamicJS';
export const loadRemote = async (name, microfrontendConfig) => {
    await loadDynamicJS(name, microfrontendConfig);
    // @ts-ignore
    await __webpack_init_sharing__('default');
    // @ts-ignore
    const container = window[name];
    if (!container || !container.init) {
        throw new Error(`Cannot load external remote: ${name}`);
    }
    // @ts-ignore
    await container.init(__webpack_share_scopes__.default);
    return container;
};
